<template>
    <!-- MODAL -->
  <TransitionRoot as="template" :show="open">
        <Dialog  class="relative z-50">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>
        <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel>
                            <div id="app">
                                <atom-spinner
                                    :animation-duration="1000"
                                    :size="100"
                                    :color="'#31b4f5'"
                                />
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script>

import {AtomSpinner} from 'epic-spinners'
import { Dialog,DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
export default {
    name: 'CommonLoading',
    data() {
    return {
        open: true
    };
    },
    props: {
    },
    methods: {
   
    },
    components:{
        AtomSpinner,
        Dialog,
        TransitionChild, 
        TransitionRoot,
        DialogPanel
    },
    setup() {
    return {
    }
    }}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
    